import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Box,
  Button,
  IconButton,
  Avatar,
} from '@mui/material';
import {
  Base64Image,
  GiftTypeEnum,
} from '../../../../utils/settings';
import OTPInput from '../../../Onboarding/Component/OtpInput';
import ResendOtp from '../../../Onboarding/Component/ResendOtp';
import { CheckCircle, FileDownloadOutlined } from '@mui/icons-material';
import DetailsCard from './DetailsCard';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { sendOTPforGiftAction, UploadGiftImage, verifyOTPforGiftAction } from '../APIs/action';
import { GiftStatusEnum } from '../utils';
import ImageUpload from '../../../Components/ImageUpload';

const GiftDetailsCard = ({ data, type, onRefresh = () => {} }) => {
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [OTPVerfied, setOTPVerfied] = useState(false);
  const navigate = useNavigate();
  const {
    sender_details,
    receiver_details,
    gift_product_details,
    status,
    announced_date,
    voucher_code,
    id,
    show_history_button,
    show_influencer_history_button,
    gift_image,
    show_send_otp_button,
  } = data;
  const tabType = type;

  const statusButtonHandler = async () => {
    const { message, error } = await sendOTPforGiftAction(id, tabType);
    if (!error) {
      toast.success(message);
      setShowOtpInput(true);
    } else {
      toast.error(message);
    }
  };

  const verifyOTP = async () => {
    const { message, error } = await verifyOTPforGiftAction(id, otp, tabType);
    if (!error) {
      toast.success(message);
      setShowOtpInput(false);
      onRefresh();
      return;
    } else {
      return toast.error(message);
    }
  };

  const getGiftStatusDetails = (status) =>
    Object.values(GiftStatusEnum).find((item) => item.status === status) || {};

  const [otp, setOtp] = useState('');
  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
  };

  const handleImageUpload = async (image_detail) => {
    const { gift_image } = image_detail;
    const payload =  {
      gift_id : id,
      type: tabType,
      gift_image
    }
    const { message, error } = await UploadGiftImage(payload);
    if (!error) {
      toast.success(message);
      onRefresh();
      return;
    } else {
      return toast.error(message);
    }
  };
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `data:image/jpeg;base64,${gift_image}`;
    link.download = 'gift_image.png';
    link.click();
  };
  return (
    <>
      <ToastContainer />
      <Grid
        container
        spacing={2}
        mt={1}
      >
         <Grid
          item
          xs={12}
          md={8}
        >
        {receiver_details && (
          
          <Grid
            item
            xs={12}
            md={12}
          >
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 3 }} gutterBottom>
              Basic Details
            </Typography>
            <Card
              sx={{
                borderRadius: '12px',
                boxShadow:
                  '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
              }}
            >
              <CardContent>
                <DetailsCard
                  details={receiver_details}
                />
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={6}
                    sm={6}
                  >
                    <Typography
                      variant="subtitle2"
                      fontWeight="bold"
                      sx={{
                        color: "#636363",
                        fontSize: "12px",
                        textTransform: 'uppercase',
                        mt: 2
                      }}
                    >
                      Status
                    </Typography>
                    <TextField
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                        },
                        '& .MuiInputBase-input': {
                          color: getGiftStatusDetails(status)?.color || '#000',
                          fontWeight: 'bold',
                        },
                        '& .Mui-disabled': {
                          WebkitTextFillColor:
                            getGiftStatusDetails(status)?.color || '#000',
                        },
                      }}
                      fullWidth
                      margin='dense'
                      size='small'
                      value={getGiftStatusDetails(status)?.label || ''}
                      disabled
                    />
                  </Grid>
                  {status === GiftStatusEnum['GIFTED'].status && show_send_otp_button && (
                    <>
                    {!gift_image && (
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="subtitle2"
                          fontWeight="bold"
                          sx={{
                            color: "#636363",
                            fontSize: "12px",
                            textTransform: 'uppercase',
                            mt: 2,
                            mb: 1
                          }}
                        >
                          Upload Image
                        </Typography>
                        
                        <Box>
                          <ImageUpload
                            onImageUpload={handleImageUpload}
                            label="Gifting Image"
                            acceptedFileTypes={['image/jpeg', 'image/png']}
                          />
                        </Box>
                      </Grid>
                    )}
                    {gift_image && (
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="subtitle2"
                          fontWeight="bold"
                          sx={{
                            color: "#636363",
                            fontSize: "12px",
                            textTransform: 'uppercase',
                            mt: 2,
                            mb: 1
                          }}
                        >
                          Uploaded Documents
                        </Typography>
                        
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            paddingX: '15px',
                            borderRadius: '10px',
                            border: '1px solid #c5c5c5',
                          }}
                        >
                          <Typography>Gift Image</Typography>
                          <IconButton onClick={handleDownload}>
                            <FileDownloadOutlined sx={{ color: 'orange' }} />
                          </IconButton>
                        </Box>
                      </Grid>
                    )}
                    </>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        )}
        {sender_details && (
          <Grid
            item
            xs={12}
            md={12}
          >
            <Typography variant="h6" fontWeight="bold" sx={{ my: 3 }} gutterBottom>
              Sender Details
            </Typography>
            <Card
              sx={{
                borderRadius: '12px',
                boxShadow:
                  '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
              }}
            >
              <CardContent>
                <DetailsCard
                  title='Sender Details'
                  details={sender_details}
                />
              </CardContent>
            </Card>
          </Grid>
        )}
        {status !== GiftStatusEnum['GIFTED'].status && show_send_otp_button &&
          status !== GiftStatusEnum['REDEEMED'].status &&
          !OTPVerfied && (
            <Grid
              item
              xs={12}
              md={12}
            >
              <Button
                variant='outlined'
                color='primary'
                sx={{
                  mt: 1,
                }}
                fullWidth
                onClick={statusButtonHandler}
              >
                {status === GiftStatusEnum['ANNOUNCED'].status &&
                  gift_product_details.gift_type ===
                    GiftTypeEnum['WHITE_GOOD'] &&
                  'Product Received in Shop'}
                {status === GiftStatusEnum['ANNOUNCED'].status &&
                  gift_product_details.gift_type === GiftTypeEnum['VOUCHER'] &&
                  'Redeem Gift Coupon'}
                {status === GiftStatusEnum['IN_SHOP'].status &&
                  'Change Status to Gifted'}
              </Button>
              {showOtpInput && (
                <Box>
                  <Typography
                    variant='subtitle2'
                    gutterBottom
                    fontSize={'.9rem'}
                    sx={{ mt: '2rem', mb: '1rem' }}
                  >
                    Enter the OTP sent to your Registered Mobile Number
                  </Typography>
                  <OTPInput
                    isDark={false}
                    onOtpChange={handleOtpChange}
                  />
                  {/* <ResendOtp onResend={sendOTPHandler} /> */}
                  <Button
                    variant='outlined'
                    color='primary'
                    sx={{
                      mt: 2,
                    }}
                    fullWidth
                    onClick={() => verifyOTP(status)}
                  >
                    Verify OTP
                  </Button>
                </Box>
              )}
            </Grid>
        )}
        {status === GiftStatusEnum['IN_SHOP'].status && OTPVerfied && (
          <Grid
            item
            xs={12}
            md={12}
          >
            <Card
              sx={{
                borderRadius: '12px',
                boxShadow:
                  '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                padding: '10px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2,
              }}
            >
              <Typography
                variant='h6'
                fontWeight='bold'
              >
                Otp Verification Done
              </Typography>
              <IconButton>
                <CheckCircle sx={{ color: 'green' }} />
              </IconButton>
            </Card>
          </Grid>
        )}
        {status === GiftStatusEnum['REDEEMED'].status &&
          gift_product_details.gift_type === GiftTypeEnum['VOUCHER'] &&
          voucher_code && (
            <Grid
              item
              xs={12}
              md={12}
            
            >
              <Card
                sx={{
                  borderRadius: '12px',
                  boxShadow:
                    '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                  padding: '10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2,
                  mt: 2,
                }}
              >
                <Typography
                  variant='h6'
                  fontWeight='bold'
                >
                  Coupon Code
                </Typography>
                <Typography
                  variant='h6'
                  fontWeight='bold'
                >
                  {voucher_code}
                </Typography>
              </Card>
            </Grid>
        )}
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              {show_history_button && (
                <Button
                  sx={{ my: 1 , background: '#fff',
                    borderRadius: '4px',
                    boxShadow:
                      '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                      color: '#5B5B5B',
                      fontWeight: 'bold',
                  }}
                  fullWidth
                  onClick={() =>
                    navigate('/benefits/rewards-history', {
                      state: {
                        reciever_id: receiver_details.company_id,
                        type: 'SELF',
                      },
                    })
                  }
                >
                  View Previous Gift History
                </Button>
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              {show_influencer_history_button && (
                <Button
                  sx={{ my: 1 , background: '#fff',
                    borderRadius: '4px',
                    boxShadow:
                      '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
                      color: '#5B5B5B',
                      fontWeight: 'bold',
                  }}
                  fullWidth
                  onClick={() =>
                    navigate('/benefits/rewards-history', {
                      state: { 
                        reciever_id: receiver_details.company_id,
                        type: 'INFLUENCER',
                      },
                    })
                  }
                >
                  View Influencers Rewards
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Typography
            variant='h6'
            fontWeight='bold'
            sx={{ mb: 2 }}
            gutterBottom
          >
            Product Details
          </Typography>
          <Card
            sx={{
              borderRadius: '12px',
              boxShadow:
                '0 0 2px 0 rgba(145, 158, 171, 0.5), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
              padding: '20px',
            }}
          >
            <Box>
              {gift_product_details && (
                <>
                  {gift_product_details?.gift_product_img ? (
                    <Box sx={{}}>
                      <Base64Image
                        base64String={gift_product_details?.gift_product_img}
                        altText={gift_product_details?.gift_product_name}
                        style={{ marginRight: '30px', width: 300, marginBottom: '20px' }}
                      />
                    </Box>
                  ) : null}
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography
                        variant='subtitle2'
                        fontWeight='bold'
                        sx={{
                          color: '#636363',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                        }}
                      >
                        Product Name
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        }}
                        fullWidth
                        margin='dense'
                        size='small'
                        value={gift_product_details?.gift_product_name}
                        disabled
                      />
                    </Grid>
                    {gift_product_details?.gift_product_brand && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                      >
                        <Typography
                          variant='subtitle2'
                          fontWeight='bold'
                          sx={{
                            color: '#636363',
                            fontSize: '12px',
                            textTransform: 'uppercase',
                          }}
                        >
                          Product Brand
                        </Typography>
                        <TextField
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '10px',
                            },
                          }}
                          fullWidth
                          margin='dense'
                          size='small'
                          value={gift_product_details?.gift_product_brand}
                          disabled
                        />
                      </Grid>
                    )}
                    <Grid
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography
                        variant='subtitle2'
                        fontWeight='bold'
                        sx={{
                          color: '#636363',
                          fontSize: '12px',
                          textTransform: 'uppercase',
                        }}
                      >
                        Annouced Date
                      </Typography>
                      <TextField
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '10px',
                          },
                        }}
                        fullWidth
                        margin='dense'
                        size='small'
                        value={announced_date}
                        disabled
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </Card>
        </Grid>
        
      </Grid>
    </>
  );
};

export default GiftDetailsCard;
